export function IconLink() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12">
            <path fill="currentColor" d="M.25 6.5A3.25 3.25 0 0 1 3.5 3.25h1a.75.75 0 0 1 0 1.5h-1a1.75 1.75 0 1 0 0 3.5h1a.75.75 0 0 1 0 1.5h-1A3.25 3.25 0 0 1 .25 6.5zm11.5 0A3.25 3.25 0 0 0 8.5 3.25h-1a.75.75 0 0 0 0 1.5h1a1.75 1.75 0 1 1 0 3.5h-1a.75.75 0 0 0 0 1.5h1a3.25 3.25 0 0 0 3.25-3.25zM4.5 5.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3z"/>
        </svg>
    );
}
